import { StyledDivider } from "./menu-item-divider.styles";

/**
 * MDSMenuItemDivider
 * This component can be used in both ActionMenu and SelectMenu
 */
export const MDSMenuItemDivider = () => {
  return <StyledDivider />;
};
